import React, { Fragment, useState, useEffect, useContext } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P } from "../AbstractElements";
import { drtsAPIURL } from '../Constant';
import { trackPromise } from 'react-promise-tracker';
import { Link, useNavigate, useSearchParams, useParams } from "react-router-dom"; 
import ReCAPTCHA from 'react-google-recaptcha';
import { ToastContainer, toast } from "react-toastify";
import OtpApp from '../Otp/App';


  export default function  Signin(){

  const history = useNavigate();
  const [omang, setOmang] = useState('');  
  const [passWordSent, setPassWordSent] = useState(false);
  const login = useState(JSON.parse(localStorage.getItem("login")))[0];
  const [loginBtnDisabled, setLoginBtnDisabled] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState('');

  const initialValues = { omang: ""}

  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const params = useParams(); //alert("Token 1 is: "+ params.token);


    const handleChange = (event) => {

    const { name, value } = event.target;

    if(event.target.name=="omang") setOmang(event.target.value);   

    setFormValues({ ...formValues, [name]: value });

    let parame=event.target.name;
    if (formErrors[parame]!=undefined&&formErrors[parame]!=null) delete formErrors[parame];
    setFormErrors(formErrors);

  }

  const handleCaptchaChange = (value) => {
        
    
    if(value!=null){ //alert(value);

        setRecaptchaValue(value);

        setFormValues({ ...formValues, ["captchaValue"]: recaptchaValue });

        if (formErrors["captchaValue"]!=undefined&&formErrors["captchaValue"]!=null) delete formErrors["captchaValue"];
        setFormErrors(formErrors);

     }
     else {
      //alert('reCaptcha is null');
      if (formValues["captchaValue"]!=undefined&&formValues["captchaValue"]!=null) delete formValues["captchaValue"];
      setFormValues(formValues);
     }
     

}

  
  const submitHandler = (e) => {

    e.preventDefault();

    //const captchaValue = ReCAPTCHA.current.getValue();
     
    if (!recaptchaValue) {
    
    }
    else{
      
      setFormValues({ ...formValues, ["captchaValue"]: recaptchaValue });
     }
    
    setFormErrors(validate(formValues));

    setIsSubmit(true);

  };

  useEffect(() => {

    if(login){
      history(`${process.env.PUBLIC_URL}/eservices/PaymentsEServices`);      
       }
  
    }, []);

 
    useEffect(() => {
      
      setFormValues({ ...formValues, ["captchaValue"]: recaptchaValue });
      
     }, [recaptchaValue]);

    useEffect(() => {

        if (Object.keys(formErrors).length === 0 && isSubmit) {

            setLoginBtnDisabled(true);

             trackPromise(
              passResetRequest(drtsAPIURL+"password_reset")
              ); 
             // toast.success("Sending");

        }
    else{

          if (Object.keys(formErrors).length > 0 && isSubmit) {
            toast.error("Please fill all the required fields. There are errors in your form.");
           }

           }

       }, [formErrors]);


    const validate = (values) => {//alert('validate');

      const errors = {};
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
          
    
      if (!values.omang) {
        errors.omang = "You must enter the Omang Number/Passport Number";
      }
        
         
      if (!values.captchaValue ||values.captchaValue==null) {//alert(recaptchaValue);
        errors.captchaValue = "You must confirm that you're human, by clicking on the checkbox.";
      }
    
          
      return errors;
    
    };

 
 
  async function passResetRequest(url) {
    try {
      await fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          omang: omang,         
        }),
      })
        .then((response) => {

          if (response.ok) {
            //console.log('hh8 -- '+JSON.stringify(respose))
            return response.json()
          }
          else{
            return response.json().then(text => { 
              //throw new Error(text) 
              if(text.message!=undefined){
              toast.error("Request failed: "+text.message);
              }
              else{
                toast.error("Request failed: Could not connect to the server");  
              }
            });
          }
        })
        .then((data) => {

          localStorage.setItem('user_id_temp', data.user.id);
         
          setLoginBtnDisabled(false);
        
          if (data.status!=null&&data.status==true&&data.status!=undefined) {

            
            setPassWordSent(true);
            toast.success(data.message);
            //history(`${process.env.PUBLIC_URL}/eservices/login`);

          } else {

            setPassWordSent(false);

            if (data.status!=null&&data.status!=undefined) {
              toast.error("Error: "+data.message);
              }
           else{
             toast.error("Ooops! An unexpected error occurred. Try again shortly.");
             }
          }
        })
    } catch (error) {
      setLoginBtnDisabled(false);
      setPassWordSent(false);
      //console.log(JSON.stringify(error));
      //toast.error("Oops...An error occurred!");
    }
  }


 

  return (
    <Fragment>
      <Container fluid={true} className="p-0 login-page">
        
       {passWordSent ? (
        <OtpApp />
       ) :
        (<Row>
          <Col xs="12">
            <div className="login-card" style={{"padding":0, "margin":0}}>

            { /* error && <div>{ error }</div> */ }
            { /*isPending && <div>Loading...</div> */}
            { /* diteng && <BlogList blogs={diteng} /> */ }

              <div className="login-main login-tab">

                <Form className="theme-form"  onSubmit={submitHandler}>

                  <H4><div style={{"color":"#6ec6ec","paddingBottom":"5px"}}>{"FORGOT PASSWORD?"}</div></H4>
                  <FormGroup>
                    <Label className="col-form-label">{"Omang/Passport Number: "}</Label>
                    <Input name="omang" className="form-control" type="text" onChange={handleChange} value={omang} />
                    <span style={{ color: 'red' }}>{formErrors.omang}</span>
                  </FormGroup>

                  <Row>
                 <Col> 

                <ReCAPTCHA onChange={(val)=>handleCaptchaChange(val)} sitekey={process.env.REACT_APP_SITE_KEY} />
                <span style={{ color: 'red' }}>{formErrors.captchaValue}</span>

                 </Col>
                </Row>
                  
                  <div className="position-relative form-group mb-0">
                    
                                  <Btn attrBtn={{ color: "primary", className: "d-block w-100 mt-2" }}>{"Submit"}</Btn>
                  </div>
                
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      )}
      
      </Container>
      <ToastContainer />
    </Fragment>
  );
}

//export default Signin;
